import { BEYOND_WORDS_SCRIPT } from "@config/beyondWords";
import { registerPlayerEvents } from "@elements/BeyondWordsPlayer/events";
import { BEYOND_WORDS_PROJECT_ID } from "@helper/getEnvVariables";
import { useAudioAnalytics } from "@hooks/useAnalyticsCall/useAudioAnalytics";
import useScript from "@hooks/useScript";
import {
  BeyondWordsPlayerConfig,
  BeyondWordsPlayerProps,
} from "@typings/BeyondWords.d";
import { useRef } from "react";

export const useBeyondWordsPlayer = ({
  cueId,
  isInfiniteScrollArticle = false,
}: BeyondWordsPlayerProps) => {
  const playerRef = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);
  const tmAudioTracking = useAudioAnalytics();

  useScript({
    src: BEYOND_WORDS_SCRIPT,
    id: "beyondwords-player-script",
    checkScriptIsLoaded: () =>
      typeof window !== "undefined" && !!window.BeyondWords,
    onLoad: () => {
      if (
        !playerRef.current ||
        isInfiniteScrollArticle ||
        initializedRef.current
      )
        return;

      initializedRef.current = true;

      const playerProps: BeyondWordsPlayerConfig = {
        target: playerRef.current,
        widgetTarget: "#tts-sticky-widget",
        widgetStyle: "none",
        projectId: BEYOND_WORDS_PROJECT_ID,
        sourceId: cueId,
        playerStyle: "standard",
        clientSideEnabled: true,
        logoIconEnabled: false,
        playlistToggle: "hide",
        downloadFormats: [],
        callToAction: "கேளுங்கள்",
        backgroundColor: "#F7F3F4",
        textColor: "#212529",
        iconColor: "#B10442",
      };

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      const player = new window.BeyondWords.Player(playerProps);

      console.log("BeyondWords Player initialized", player);
      registerPlayerEvents(player, tmAudioTracking);

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      window.beyondWordsPlayerInstance = player;
    },
  });

  return playerRef;
};
